import { render } from "./ScreenSchedule.vue?vue&type=template&id=1266f978&scoped=true"
import script from "./ScreenSchedule.vue?vue&type=script&lang=js"
export * from "./ScreenSchedule.vue?vue&type=script&lang=js"

import "./ScreenSchedule.vue?vue&type=style&index=0&id=1266f978&scoped=true&lang=css"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1266f978"]])

export default __exports__